var exports = {
  "ns": "Attachment.module__attachmentWrapper___eUlYeX",
  "yf": "Attachment.module__expiredOverlay___eUlYeX",
  "ri": "Attachment.module__expiredContent___eUlYeX",
};

module.exports = exports;
